import { useAppContext } from '@common/contexts/AppContext';
import { Property, usePropertyModules } from '@features/properties';

type FeaturedModuleVisibility = {
  isFeaturedSpaDaysVisible: boolean;
  isFeaturedSpaTreatmentsVisible: boolean;
  isFeaturedEventsVisible: boolean;
  isFeaturedVouchersVisible: boolean;
};

type ModulesExcludingDisabled = Property['modules_excluding_disabled'];

export function getFeaturedModuleVisibility(
  modules: ModulesExcludingDisabled
): FeaturedModuleVisibility {
  const isSpaEnabled = modules?.spa?.enabled ?? false;
  const isFeaturedSpaDaysVisible = (isSpaEnabled && modules?.spa?.features?.days?.enabled) ?? false;
  const isFeaturedSpaTreatmentsVisible =
    (isSpaEnabled && modules?.spa?.features?.treatments?.enabled) ?? false;
  const isFeaturedEventsVisible = false;
  const isFeaturedVouchersVisible = false;
  return {
    isFeaturedSpaDaysVisible,
    isFeaturedSpaTreatmentsVisible,
    isFeaturedEventsVisible,
    isFeaturedVouchersVisible,
  };
}

export function useFeaturedModuleVisibility(): FeaturedModuleVisibility {
  const { siteId } = useAppContext();
  const { data: modules } = usePropertyModules(siteId);

  if (!modules) {
    return {
      isFeaturedSpaDaysVisible: false,
      isFeaturedSpaTreatmentsVisible: false,
      isFeaturedEventsVisible: false,
      isFeaturedVouchersVisible: false,
    };
  }

  return getFeaturedModuleVisibility(modules);
}
